<template>
  <SogPage title="Stornierungen (beta)">
    <SogCard>
      <SogCardActions :is-toolbar="true">
        <SogTextBox
          v-model="_listPage.number"
          placeholder="VR-Nummer"
          :interval-modified="onSearch"
        />
        <SogTextBox
          v-model="_listPage.personName"
          placeholder="Kunde"
          :interval-modified="onSearch"
        />
        <div style="width: 20%">
          <SogDropDownList
            v-model="_listPage.status"
            placeholder="Status"
            :data-source="_lstStatus"
            :fields="_fields"
            popup-width="auto"
          />
        </div>
        <SogCardActionButton
          :kind="SogButtonKind.Search"
          style="align-self: flex-end"
          @click="search"
        />
        <SogCardActionButton
          :kind="SogButtonKind.Back"
          style="align-self: flex-end"
        />
      </SogCardActions>
      <SogCardContent>
        <SogGrid
          id="cancelationList"
          ref="_cancelationList"
          :url="_url"
          :columns="_columns"
          :on-command-click="onClick"
          width="auto"
        />
      </SogCardContent>
    </SogCard>
  </SogPage>
</template>

<script setup lang="ts">

import SogPage from "@/shared/ui/SogPage.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import {SogButtonKind} from "@/shared/ui/types/SogButtonKind";
import {ref, onMounted, watch, reactive} from "vue";
import SogTextBox from "@/shared/ui/SogTextBox.vue";
import {storeToRefs} from "pinia";
import {useInsuranceCancelationStore} from "@/modules/InsuranceCancelation/store";
import SogGrid from "@/shared/ui/SogGrid.vue";
import {Api} from "@/shared/services/api";
import {useNavigationStore} from "@/modules/Navigation/store";
import {ColumnModel} from "@syncfusion/ej2-grids/src/grid/models/column";
import {DateTimeColumn, DefaultColumn} from "@/shared/ui/types/SogGridColumnDefinitions";
import {IdType} from "@/shared/model/idType";
import SogDropDownList from "@/shared/ui/SogDropDownList.vue";




const _insuranceCancelationStore = useInsuranceCancelationStore()
const {listPage: _listPage} = storeToRefs(_insuranceCancelationStore);
const _url = Api.baseUrl + '/InsuranceCancelationList';
const _cancelationList = ref<InstanceType<typeof SogGrid> | null>(null)
const _buttonId = ref("");
const _navigationStore = useNavigationStore();


const _lstStatus = reactive([
  {id: "ToAllow", value: "Zur Prüfung"},
  {id: "Allowed", value: "Genehmigt"},
  {id: "Ordered", value: "Gutgeschrieben"},
  {id: "Rejected", value: "Abgelehnt"},
  {id: "all", value: "Alle"},
]);
const _fields = {text: "value", value: "id"};

const _columns: ColumnModel[] = [
  {
    ...DefaultColumn,
    headerText: "",
    visible: true,
    commands: [
      {
        buttonOption: {
          cssClass: "e-flat",
          iconCss: "e-circle-info e-icons",
          click: onClickDetails,
        },
      },
    ],
    textAlign: "Left",
    uid: "details",
    autoFit: true,
    width: "60px",
  },
  {...DefaultColumn, field: "insuranceNumber", headerText: "VSNR", autoFit: true},
  {
    ...DateTimeColumn,
    field: "cancelationRequestDate",
    headerText: "Stornierungsanfrage",
    allowSorting: false,
    autoFit: true,
  },
  {
    ...DateTimeColumn,
    field: "cancelationDate",
    headerText: "Stornierungsdatum",
    allowSorting: false,
    autoFit: true,
  },
  {
    ...DefaultColumn,
    field: "cancelationStatusDescription",
    headerText: "Stornierungsstatus",
    allowSorting: false,
    autoFit: true,
  },
  {
    ...DefaultColumn,
    field: "personName",
    headerText: "Kunde",
    autoFit: true,
  }
];

async function onClick(args: any) {
  _navigationStore.currentInsuranceCancelationId = args.rowData.id;
  if (_buttonId.value === "details") {
    await _navigationStore.showObject(IdType.InsuranceCancelation, args.rowData.id);
  }
}

async function onClickDetails() {
  _buttonId.value = "details";
}

function search() {
  if (!_cancelationList.value || !_cancelationList.value.adaptor) return;
  _cancelationList.value?.adaptor.removePredicate("number");
  if (_listPage.value.number){
    _cancelationList.value?.adaptor.addPredicate(
      "number",
      "contains",
      _listPage.value.number.toUpperCase()
    );
  }
  _cancelationList.value?.adaptor.removePredicate("personName");
  if (_listPage.value.personName){
    _cancelationList.value?.adaptor.addPredicate(
        "personName",
        "contains",
        _listPage.value.personName.toUpperCase()
    );
  }
  _cancelationList.value?.adaptor?.removePredicate("cancelationStatus");
  if (_listPage.value.status !== "all") {
    _cancelationList.value?.adaptor.addPredicate(
      "cancelationStatus",
      "equal",
      _listPage.value.status
    );
  }

  _cancelationList.value?.refresh();
}

onMounted(() => {
  search();
});

watch(_listPage.value, () => {
  search();
});

function onSearch() {
  search();
}
</script>

<style scoped>

</style>
